import { ReactNode } from 'react';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { UserSidebar } from '@/components/user/UserSidebar';
import Navigation from '@/components/Navigation';
import { useIsMobile } from '@/hooks/use-mobile';

interface UserAccountLayoutProps {
  children: ReactNode;
}

export function UserAccountLayout({ children }: UserAccountLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div className="flex min-h-screen w-full bg-background">
        {/* Desktop Sidebar */}
        {!isMobile && <UserSidebar />}
        
        <SidebarInset className="flex-1 flex flex-col w-full">
          {/* Desktop: Full Navigation */}
          {!isMobile && <Navigation />}
          
          {/* Main Content Area */}
          <main className="app-main flex-1 overflow-auto w-full">
            <div className="h-full w-full">
              {children}
            </div>
          </main>
        </SidebarInset>
      </div>
      
      {/* BottomNavBar rendered centrally in App.tsx for mobile */}
    </SidebarProvider>
  );
}